export const CATEGORIES_INDEX              = '@@CATEGORIES_INDEX'
export const CATEGORIES_SHOW               = '@@CATEGORIES_SHOW'

export const NEWS_SELECT                   = '@@NEWS_SELECT'
export const NEWS_INDEX                    = '@@NEWS_INDEX'
export const NEWS_SHOW                     = '@@NEWS_SHOW'

export const BLOGS_INDEX                   = '@@BLOGS_INDEX'
export const BLOGS_SELECT                  = '@@BLOGS_SELECT'
export const BLOGS_SHOW                    = '@@BLOGS_SHOW'



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/actionTypes.js